import { render, staticRenderFns } from "./contractperformance.vue?vue&type=template&id=20716cdc&scoped=true"
import script from "./contractperformance.vue?vue&type=script&lang=js"
export * from "./contractperformance.vue?vue&type=script&lang=js"
import style0 from "./contractperformance.vue?vue&type=style&index=0&id=20716cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20716cdc",
  null
  
)

export default component.exports